"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var uom_1 = require("uom");
var uom_units_1 = require("uom-units");
// tslint:disable-next-line:variable-name
var Rda = 287.042; // specific gas constant for dry air, J/(kg·K)
var R = 8.3144621; // molar (or universal) gas constant, J/(mol·K)
// const Rw = 461.495; // specific gas constant for water vapor, J/(kg·K)
var L = 0.0065; // temperature lapse rate, K/m                      (ASHRAE, U.S. STANDARD ATMOSPHERE)
var p0 = 101325.0; // sea level standard atmospheric pressure, Pa      (ASHRAE, U.S. STANDARD ATMOSPHERE)
var T0 = 288.15; // sea level standard temperature, K                (ASHRAE, U.S. STANDARD ATMOSPHERE)
var g = 9.80665; // Earth-surface gravitational acceleration, m/s2   (ASHRAE, U.S. STANDARD ATMOSPHERE)
var M = 0.0289644; // molar mass of dry air, kg/mol
function calculateDensityOfMoistAirMixture(drybulbTemperature, totalPressure, humidity) {
    // Calculate density ρ of a moist air mixture
    // ASHRAE Fundamentals (2009) ch. 1.8 eqn11
    //
    // ra = (Mda + Mwa) / V = (1/v)(1+W) (eq11)
    // v is the moist air specific volume, m3/kgda given by eq26, eq27 and eq28
    // v = 0.287042 * T (1 + 1.607858 * W) / p (eq28)
    // T is absolute temperature, Kelvin
    // p is total pressure, kPa
    // W is humidity ratio, kgw/kgda
    // Rda = gas constant for dry air, kJ/(kgda·K)
    // pw = partial pressure of water vapor
    // tslint:disable-next-line:variable-name
    var Rda_inKJ = Rda / 1000;
    var v = Rda_inKJ * uom_1.Amount.valueAs(uom_units_1.Units.Kelvin, drybulbTemperature)
        * (1 + 1.607858 * uom_1.Amount.valueAs(uom_units_1.Units.KilogramPerKilogram, humidity)) / uom_1.Amount.valueAs(uom_units_1.Units.KiloPascal, totalPressure);
    var ra = 1 / v * (1 + uom_1.Amount.valueAs(uom_units_1.Units.KilogramPerKilogram, humidity));
    return uom_1.Amount.create(ra, uom_units_1.Units.KilogramPerCubicMeter);
}
exports.calculateDensityOfMoistAirMixture = calculateDensityOfMoistAirMixture;
function calculateAtmosphericPressure(altitudeAboveSeaLevel) {
    // http://en.wikipedia.org/wiki/Density_of_air
    // same as the ASHRAE formula, but this is more accurate using various more exact constants.
    // ASHRAE Fundamentals (2009) ch. 1.1 eqn. 3
    // return Amount.Create(
    //   101325 * Math.Pow((1 - 2.25577 * 0.00001 * altitudeAboveSeaLevel.ValueAs(Units.Meter)), 5.2559)
    //   , Units.Pascal);
    return uom_1.Amount.create(p0 * Math.pow(1 - L * uom_1.Amount.valueAs(uom_units_1.Units.Meter, altitudeAboveSeaLevel) / T0, (g * M) / (R * L)), uom_units_1.Units.Pascal);
}
exports.calculateAtmosphericPressure = calculateAtmosphericPressure;
